import { Availability } from "@caredna-marlin/utils/client/availability";
import { Button, Dialog, DialogActions, DialogContent, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { AvailabilityByTimespanQuery, AvailTzHandling } from "~/graphql/__generated__/graphql";
import { AvailabilityTableRow } from "./AvailabilityTable";
import BulkOperation from "./BulkOperation";
import { useState } from "react";
import useAvailabilityOperation from "~/hooks/useAvailabilityOperation";
import SaveWithTimezoneHandling from "./SaveWithTimezoneHandling";

type Props = {
  availability: Availability[],
  onClose: () => void,
  provider: AvailabilityByTimespanQuery["provider"][number],
}

const ProviderAsTemplateDialog = ({ availability, onClose, provider }: Props) => {
  const { onSaveTemplate, loading } = useAvailabilityOperation();
  const [selected, setSelected] = useState(availability.map(a => a.id));
  const [additionalProviders, setAdditionalProviders] = useState<Record<string, boolean>>({});

  const providerIds = Object.keys(additionalProviders).filter(id => additionalProviders[id]).map(id => parseInt(id));

  const onSave = async (tzHandling: AvailTzHandling) => {
    await onSaveTemplate(selected, providerIds, tzHandling);
    onClose();
  }

  const exampleAvail = availability.find(a => selected.includes(a.id)) || availability[0]

  return <Dialog open={true} onClose={onClose} maxWidth={false}>
    <DialogContent sx={{ width: 1600 }}>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid size={12}>
          <Typography variant="h6" sx={{ textAlign: "center" }}>
            Use {provider.firstName} {provider.lastName} as template
          </Typography>
        </Grid>
        <Table sx={{ mb: 1 }} size="small">
          <TableHead>
            <TableRow>
              <TableCell colSpan={6}>Copy the selected items onto other providers' schedules, replacing everything except their time off</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {availability.map(avail => <AvailabilityTableRow
              avail={avail}
              key={avail.id}
              setEditing={null}
              selected={selected?.includes(avail.id) || false}
              setSelected={(s) => setSelected(s ? [...selected, avail.id] : selected.filter(id => id !== avail.id))}
            />)}
          </TableBody>
        </Table>
      </Grid>

      <BulkOperation
        action={"template"}
        availability={availability[0]}
        additionalProviders={additionalProviders}
        expanded={true}
        setAdditionalProviders={setAdditionalProviders}
        setAdditionalAvailabilityIds={() => {}}
      />
    </DialogContent>
    <DialogActions>
      <Button disabled={loading} onClick={onClose}>
        Cancel
      </Button>
      <SaveWithTimezoneHandling
        availability={exampleAvail}
        additionalProviders={additionalProviders}
        action="template"
        onSave={onSave}
        loading={loading}
        disabled={!providerIds.length || !selected.length}
      />
    </DialogActions>
  </Dialog>
}

export default ProviderAsTemplateDialog;
